import { configureStore } from "@reduxjs/toolkit";
import ChartReducer from "./ChartSlice";
import CentreSupervisorReducer from "./CentreSupervisorSlice";
import { filterReducer, listBookFilterReducer } from "./purchaseBookFilterSlice";
import CreateBooksetReducer from "./CreateBooksetSlice";
const store = configureStore({
  reducer: {
    chart: ChartReducer,
    centreSupervisor: CentreSupervisorReducer,
    filterBooks: filterReducer,
    listBookFilter: listBookFilterReducer,
    books: CreateBooksetReducer,
  },
});

export default store;
